import React, { Component } from "react";
import StepWizard from 'react-step-wizard';
//// componentes reutilizables
import Titulo from "../../../generico/TituloPagina";
import ModificarPaso1 from "./ModificarPaso1";
import ModificarPaso2 from "./ModificarPaso2";

export default class AgregarSubsidio extends Component {
  constructor(props) {
    super(props);
    this.state = {
      nroSubsidio: undefined, 
      cantidadArchivos: undefined, 
      datosSubsidio: undefined,
    };
  }

  respuestaPaso1 = (cantidadArchivos, datosSubsidio) => {
    this.setState({
      nroSubsidio: datosSubsidio.nroSolicitud, 
      cantidadArchivos: cantidadArchivos, 
      datosSubsidio: datosSubsidio,
    });
  };

 
  render() {
      return (
        <div className="content-wrapper">
          <Titulo texto="Modificar Subsidios"/>
          <section className="content">
            <div className="container">
              <div className="row">
                <div className="col-md-12">
                  <div className="card">
                    <div className="card-body">
                          <StepWizard transitions='none'>
                              <ModificarPaso1 respuestaPaso1={this.respuestaPaso1.bind(this)}/>
                              <ModificarPaso2 respuestasData={this.state}/>
                          </StepWizard> 
                     </div>    
                  </div>                    
                </div> 
              </div>
            </div>           
          </section> 
        </div>
     
      );
  }
}